import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmRadioFeild = class AmRadioFeild extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.ruleForm = {
      value: ''
    };
  }
};
AmRadioFeild.componentName = 'AmRadioFeild';
__decorate([Prop([String, Number, Boolean])], AmRadioFeild.prototype, "options", void 0);
__decorate([Prop(String)], AmRadioFeild.prototype, "shape", void 0);
__decorate([Prop(String)], AmRadioFeild.prototype, "itemDirection", void 0);
__decorate([Prop(String)], AmRadioFeild.prototype, "border", void 0);
AmRadioFeild = __decorate([Component({
  name: 'AmRadioFeild'
})], AmRadioFeild);
export default AmRadioFeild;